import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {EmpresasService} from "../superadmin/services/empresas.service";
import {BehaviorSubject} from "rxjs";
import {ArmazenamentoService} from "../services/armazenamento.service";
import {ConfiguracoesNotaFiscalService} from "./fiscal/services/configuracoes-nota-fiscal.service";



@Injectable()
export class ConstantsService {
  private fallbackRecursosLegados: any = {
    atendimento_garcom: ModulosEnum.GARCOM,
    controle_fiado: ModulosEnum.FIADO,
    tabela_precos: ModulosEnum.TABELA_PRECOS,
    comissionamento: ModulosEnum.COMISSIONAMENTO,
    google_maps_taxas: ModulosEnum.GOOGLE_MAPS,
    chatbot_instagram: ModulosEnum.CHATBOT_INSTAGRAM,
    dominio_proprio: ModulosEnum.DOMINIO_PROPRIO,
    operador_extra: ModulosEnum.OPERADOR_EXTRA,
    estoque: ModulosEnum.CONTROLE_ESTOQUE,
    fiscal: ModulosEnum.FISCAL,
    kds_cozinha: ModulosEnum.KDS
  };
  private recursosPorModuloLegado: any = {
    [ModulosEnum.GARCOM]: RecursosEnum.ATENDIMENTO_GARCOM,
    [ModulosEnum.FIADO]: RecursosEnum.CONTROLE_FIADO,
    [ModulosEnum.TABELA_PRECOS]: RecursosEnum.TABELA_PRECOS,
    [ModulosEnum.COMISSIONAMENTO]: RecursosEnum.COMISSIONAMENTO,
    [ModulosEnum.GOOGLE_MAPS]: RecursosEnum.GOOGLE_MAPS_TAXAS,
    [ModulosEnum.CHATBOT_INSTAGRAM]: RecursosEnum.CHATBOT_INSTAGRAM,
    [ModulosEnum.DOMINIO_PROPRIO]: RecursosEnum.DOMINIO_PROPRIO,
    [ModulosEnum.OPERADOR_EXTRA]: RecursosEnum.OPERADOR_EXTRA,
    [ModulosEnum.PDV]: RecursosEnum.CAIXA,
    [ModulosEnum.CONTROLE_ESTOQUE]: RecursosEnum.ESTOQUE,
    [ModulosEnum.FISCAL]: RecursosEnum.FISCAL,
    [ModulosEnum.KDS]: RecursosEnum.KDS_COZINHA
  };

  private moduloPedido = new BehaviorSubject<boolean>(null);
  private moduloFidelidade = new BehaviorSubject<boolean>(null);
  private moduloChatbot = new BehaviorSubject<boolean>(false);
  private moduloMiaV3 = new BehaviorSubject<boolean>(false);
  private moduloChatbotInstagram = new BehaviorSubject<boolean>(false);
  private moduloGarcom = new BehaviorSubject<boolean>(false);
  private moduloApp = new BehaviorSubject<boolean>(false);
  private moduloEntregadores = new BehaviorSubject<boolean>(false);
  private moduloPdv = new BehaviorSubject<boolean>(false);
  private moduloMesasGarcom = new BehaviorSubject<boolean>(false);
  private moduloKDS = new BehaviorSubject<boolean>(false);
  private recursoGoogleMapsTaxas = new BehaviorSubject<boolean>(false);
  private recursoAvaliacoesPedidos = new BehaviorSubject<boolean>(false);
  private recursoImpressaoAutomatica = new BehaviorSubject<boolean>(false);
  private recursoNotificacoesWhatsappPedidos = new BehaviorSubject<boolean>(false);
  private recursoIntegracaoGatewayPagamento = new BehaviorSubject<boolean>(false);
  private recursoIntegracaoPdvParceiros = new BehaviorSubject<boolean>(false);
  private recursoIntegracaoDeliveryParceiros = new BehaviorSubject<boolean>(false);
  private recursoIntegracaoMarketplacesDelivery = new BehaviorSubject<boolean>(false);
  private recursoVitrines = new BehaviorSubject<boolean>(false);
  private recursoCuponsAvancados = new BehaviorSubject<boolean>(false);
  private recursoTemasPersonalizados = new BehaviorSubject<boolean>(false);
  private recursoLinkNaBio = new BehaviorSubject<boolean>(false);
  private recursoInteligenciaNegocio = new BehaviorSubject<boolean>(false);
  private recursoMiaAtendente = new BehaviorSubject<boolean>(false);
  private recursoCampanhasWhatsapp = new BehaviorSubject<boolean>(false);
  private recursoNotificacoesAppProprio = new BehaviorSubject<boolean>(false);
  private recursoFerramentasMarketing = new BehaviorSubject<boolean>(false);
  private moduloFiado = new BehaviorSubject<boolean>(false);
  private moduloFiscal = new BehaviorSubject<boolean>(false);
  private emissaoNotaFiscalAtiva = new BehaviorSubject<boolean>(false);
  private impressaoAutomaticaNfce = new BehaviorSubject<boolean>(false);
  private moduloEstoque = new BehaviorSubject<boolean>(false);
  private moduloTabelaPrecos = new BehaviorSubject<boolean>(false);
  private moduloComissionamento = new BehaviorSubject<boolean>(false);
  private somenteCardapio = new BehaviorSubject<boolean>(null);
  private exibirProdutos = new BehaviorSubject<boolean>(null);
  private empresa = new BehaviorSubject<any>(null);
  private campoCpf = new BehaviorSubject<any>(null);
  private campoCnpj = new BehaviorSubject<any>(null);
  private campoDataNascimento = new BehaviorSubject<any>(null);

  moduloPedido$ = this.moduloPedido.asObservable();
  moduloFidelidade$ = this.moduloFidelidade.asObservable();
  moduloChatbot$ = this.moduloChatbot.asObservable();
  moduloMiaV3$ = this.moduloMiaV3.asObservable();
  somenteCardapio$ = this.somenteCardapio.asObservable();
  exibirProdutos$ = this.exibirProdutos.asObservable();
  moduloGarcom$ = this.moduloGarcom.asObservable();
  moduloEntregadores$ = this.moduloEntregadores.asObservable();
  moduloPdv$ = this.moduloPdv.asObservable();
  moduloMesasGarcom$ = this.moduloMesasGarcom.asObservable();
  possuiModuloKDS$ = this.moduloKDS.asObservable();
  moduloFiado$ = this.moduloFiado.asObservable();
  moduloFiscal$ = this.moduloFiscal.asObservable();
  emissaoNotaFiscalAtiva$ = this.emissaoNotaFiscalAtiva.asObservable();
  impressaoAutomaticaNfce$ = this.impressaoAutomaticaNfce.asObservable();
  moduloEstoque$ = this.moduloEstoque.asObservable();
  moduloTabelaPrecos$ = this.moduloTabelaPrecos.asObservable();
  moduloComissionamento$ = this.moduloComissionamento.asObservable();
  recursoAtendimentoGarcom$ = this.moduloGarcom.asObservable();
  recursoControleFiado$ = this.moduloFiado.asObservable();
  recursoTabelaPrecos$ = this.moduloTabelaPrecos.asObservable();
  recursoComissionamento$ = this.moduloComissionamento.asObservable();
  recursoGoogleMapsTaxas$ = this.recursoGoogleMapsTaxas.asObservable();
  recursoAvaliacoesPedidos$ = this.recursoAvaliacoesPedidos.asObservable();
  recursoImpressaoAutomatica$ = this.recursoImpressaoAutomatica.asObservable();
  recursoNotificacoesWhatsappPedidos$ = this.recursoNotificacoesWhatsappPedidos.asObservable();
  recursoIntegracaoGatewayPagamento$ = this.recursoIntegracaoGatewayPagamento.asObservable();
  recursoIntegracaoPdvParceiros$ = this.recursoIntegracaoPdvParceiros.asObservable();
  recursoIntegracaoDeliveryParceiros$ = this.recursoIntegracaoDeliveryParceiros.asObservable();
  recursoIntegracaoMarketplacesDelivery$ = this.recursoIntegracaoMarketplacesDelivery.asObservable();
  recursoVitrines$ = this.recursoVitrines.asObservable();
  recursoCuponsAvancados$ = this.recursoCuponsAvancados.asObservable();
  recursoTemasPersonalizados$ = this.recursoTemasPersonalizados.asObservable();
  recursoLinkNaBio$ = this.recursoLinkNaBio.asObservable();
  recursoInteligenciaNegocio$ = this.recursoInteligenciaNegocio.asObservable();
  recursoMiaAtendente$ = this.recursoMiaAtendente.asObservable();
  recursoCampanhasWhatsapp$ = this.recursoCampanhasWhatsapp.asObservable();
  recursoNotificacoesAppProprio$ = this.recursoNotificacoesAppProprio.asObservable();
  recursoFerramentasMarketing$ = this.recursoFerramentasMarketing.asObservable();
  recursoEstoque$ = this.moduloEstoque.asObservable();
  recursoFiscal$ = this.moduloFiscal.asObservable();
  recursoKdsCozinha$ = this.moduloKDS.asObservable();
  moduloApp$ = this.moduloApp.asObservable();
  moduloChatbotInstagram$  = this.moduloChatbotInstagram.asObservable();

  empresa$ = this.empresa.asObservable();
  campoCpf$ = this.campoCpf.asObservable();
  campoCnpj$ = this.campoCnpj.asObservable();
  campoDataNascimento$ = this.campoDataNascimento.asObservable();
  produtosLoja: any = [];
  insumosDaLoja: any = [];
  insumosEmAlerta: any = [];
  gruposDeInsumo: any = [];
  diasDaSemana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

  KEYNAOIMPRIMIR = 'nao-imprimir'
  KEYDESATIVARALERTAGARCOM = 'desativar-alerta-garcom'
  KEYPDVMOSTRARFOTOS = 'pdv-mostrar-fotos'
  naoImprimir: boolean
  naoTocarGarcom: boolean;
  pdvMostrarFotos: boolean = true;


  constructor(private httpClient: HttpClient,  private empresasService: EmpresasService,
              private armazenamentoService: ArmazenamentoService,
              private configuracoesNotaFiscalService: ConfiguracoesNotaFiscalService) {
    this.empresasService.logada().then( (empresa: any) => {
      if(!empresa || !empresa.id) {
        this.empresa.next(null);
        return;
      }

      this.carregueInformacoesDeHorarioDeFuncionamento(empresa);

      this.empresa.next ( empresa );

      this.moduloChatbot.next(this.possuiRecurso(empresa, RecursosEnum.MIA_ATENDENTE));
      this.moduloMiaV3.next(this.possuiRecurso(empresa, RecursosEnum.MIA_V3));
      this.moduloChatbotInstagram.next(this.possuiRecurso(empresa, RecursosEnum.CHATBOT_INSTAGRAM));
      this.moduloPedido.next(this.possuiModulo(empresa, ModulosEnum.PEDIDOS));
      this.moduloKDS.next(this.possuiRecurso(empresa, RecursosEnum.KDS_COZINHA));
      this.moduloFidelidade.next(this.possuiModulo(empresa, ModulosEnum.FIDELIDADE));
      this.somenteCardapio.next(this.possuiApenasModulo(empresa, ModulosEnum.CARDAPIO));
      this.moduloGarcom.next(this.possuiRecurso(empresa, RecursosEnum.ATENDIMENTO_GARCOM));
      this.moduloEntregadores.next(this.possuiModulo(empresa, ModulosEnum.ENTREGADORES));
      this.moduloPdv.next(this.possuiRecurso(empresa, RecursosEnum.CAIXA));
      this.moduloMesasGarcom.next(this.possuiModulo(empresa, ModulosEnum.MESAS_GARCOM));
      this.moduloEstoque.next(this.possuiRecurso(empresa, RecursosEnum.ESTOQUE));
      this.recursoGoogleMapsTaxas.next(this.possuiRecurso(empresa, RecursosEnum.GOOGLE_MAPS_TAXAS));
      this.moduloTabelaPrecos.next(this.possuiRecurso(empresa, RecursosEnum.TABELA_PRECOS));
      this.moduloComissionamento.next(this.possuiRecurso(empresa, RecursosEnum.COMISSIONAMENTO));
      this.moduloApp.next(this.possuiModulo(empresa, ModulosEnum.APP));
      this.moduloFiado.next(this.possuiRecurso(empresa, RecursosEnum.CONTROLE_FIADO));
      this.moduloFiscal.next(this.possuiRecurso(empresa, RecursosEnum.FISCAL));
      this.atualizeRecursosSoltos(empresa);
      this.recarregueConfiguracaoFiscal(empresa);
      this.exibirProdutos.next(this.temPedidos(empresa));
      this.campoCpf.next( this.possuiCampoExtra(empresa, 'cpf'));
      this.campoCnpj.next( this.possuiCampoExtra(empresa, 'cnpj'));
      this.campoDataNascimento.next( this.possuiCampoExtra(empresa, 'datanascimento'));
    });
    try {
      if(this.armazenamentoService.carregue(this.KEYNAOIMPRIMIR, false) === '1')
        this.naoImprimir =  true;

      if(this.armazenamentoService.carregue(this.KEYDESATIVARALERTAGARCOM, false) === '1')
        this.naoTocarGarcom = true;

      const fotosFlag = this.armazenamentoService.carregue(this.KEYPDVMOSTRARFOTOS, false);
      this.pdvMostrarFotos = fotosFlag !== '0';

    }catch(e)
    {}
  }

  temPedidos(empresa: any): boolean {
    return this.possuiModulo(empresa, ModulosEnum.CARDAPIO) || this.possuiModulo(empresa, ModulosEnum.PEDIDOS);
  }

  possuiCampoExtra(empresa: any, nomeCampo){
    if(!empresa || !empresa.camposExtras) return false;

    return empresa.camposExtras.find(campoExtra =>   campoExtra.nome === nomeCampo) != null;
  }

  possuiModulo(empresa: any, nomeModulo: string) {
    if(!empresa || !empresa.modulos) return false;

    const possuiModuloLegado = this.possuiModuloLegado(empresa, nomeModulo);
    const recursoEquivalente = this.recursosPorModuloLegado[nomeModulo];

    if(recursoEquivalente)
      return possuiModuloLegado || this.possuiRecursoAtivo(empresa, recursoEquivalente);

    return possuiModuloLegado;
  }

  private possuiModuloLegado(empresa: any, nomeModulo: string) {
    if(!empresa || !empresa.modulos) return false;

    return empresa.modulos.some(modulo =>   modulo.nome === nomeModulo);
  }

  possuiRecurso(empresa: any, slugRecurso: string) {
    if(!empresa || !slugRecurso) return false;

    if(this.possuiRecursoAtivo(empresa, slugRecurso)) return true;

    const moduloLegado = this.fallbackRecursosLegados[slugRecurso];
    return moduloLegado ? this.possuiModuloLegado(empresa, moduloLegado) : false;
  }

  private possuiRecursoAtivo(empresa: any, slugRecurso: string) {
    return Array.isArray(empresa?.recursosAtivos) && empresa.recursosAtivos.some(recurso => recurso === slugRecurso);
  }

  possuiModuloOuRecurso(empresa: any, nomeModuloLegado: string, slugRecurso: string) {
    return this.possuiRecurso(empresa, slugRecurso) || this.possuiModulo(empresa, nomeModuloLegado);
  }

  possuiApenasModulo(empresa: any, nomeModulo: string) {
    if(!empresa || !empresa.modulos) return false;

    return empresa.modulos.length === 1 && this.possuiModulo(empresa, nomeModulo);
  }

  recarregueEmpresa(cb = null) {
    return this.empresasService.logada().then((empresa: any) => {
      if(!empresa || !empresa.id) {
        this.empresa.next(null);
        if (cb) cb(null);
        return;
      }

      this.empresa.next(empresa);
      this.moduloChatbot.next(this.possuiRecurso(empresa, RecursosEnum.MIA_ATENDENTE));
      this.moduloMiaV3.next(this.possuiRecurso(empresa, RecursosEnum.MIA_V3));
      this.moduloChatbotInstagram.next(this.possuiRecurso(empresa, RecursosEnum.CHATBOT_INSTAGRAM));
      this.moduloPedido.next(this.possuiModulo(empresa, ModulosEnum.PEDIDOS));
      this.moduloKDS.next(this.possuiRecurso(empresa, RecursosEnum.KDS_COZINHA));
      this.moduloFidelidade.next(this.possuiModulo(empresa, ModulosEnum.FIDELIDADE));
      this.somenteCardapio.next(this.possuiApenasModulo(empresa, ModulosEnum.CARDAPIO));
      this.moduloGarcom.next(this.possuiRecurso(empresa, RecursosEnum.ATENDIMENTO_GARCOM));
      this.moduloEntregadores.next(this.possuiModulo(empresa, ModulosEnum.ENTREGADORES));
      this.moduloPdv.next(this.possuiRecurso(empresa, RecursosEnum.CAIXA));
      this.moduloMesasGarcom.next(this.possuiModulo(empresa, ModulosEnum.MESAS_GARCOM));
      this.moduloEstoque.next(this.possuiRecurso(empresa, RecursosEnum.ESTOQUE));
      this.moduloFiado.next(this.possuiRecurso(empresa, RecursosEnum.CONTROLE_FIADO));
      this.moduloFiscal.next(this.possuiRecurso(empresa, RecursosEnum.FISCAL));
      this.recursoGoogleMapsTaxas.next(this.possuiRecurso(empresa, RecursosEnum.GOOGLE_MAPS_TAXAS));
      this.moduloTabelaPrecos.next(this.possuiRecurso(empresa, RecursosEnum.TABELA_PRECOS));
      this.moduloComissionamento.next(this.possuiRecurso(empresa, RecursosEnum.COMISSIONAMENTO));
      this.moduloApp.next(this.possuiModulo(empresa, ModulosEnum.APP));
      this.atualizeRecursosSoltos(empresa);
      this.recarregueConfiguracaoFiscal(empresa);
      this.exibirProdutos.next(this.temPedidos(empresa));
      this.campoCpf.next(this.possuiCampoExtra(empresa, 'cpf'));
      this.campoCnpj.next(this.possuiCampoExtra(empresa, 'cnpj'));

      if (cb) cb(empresa);

    }).catch((error) => {});
  }

  mudouEmpresa(empresa: any) {
    localStorage.setItem('alterouEmpresa', new Date().getTime().toString());
    this.empresa.next( empresa);
    this.moduloChatbot.next(this.possuiRecurso(empresa, RecursosEnum.MIA_ATENDENTE));
    this.moduloChatbotInstagram.next(this.possuiRecurso(empresa, RecursosEnum.CHATBOT_INSTAGRAM));
    this.moduloKDS.next(this.possuiRecurso(empresa, RecursosEnum.KDS_COZINHA));
    this.moduloGarcom.next(this.possuiRecurso(empresa, RecursosEnum.ATENDIMENTO_GARCOM));
    this.moduloPdv.next(this.possuiRecurso(empresa, RecursosEnum.CAIXA));
    this.moduloMesasGarcom.next(this.possuiModulo(empresa, ModulosEnum.MESAS_GARCOM));
    this.moduloEstoque.next(this.possuiRecurso(empresa, RecursosEnum.ESTOQUE));
    this.moduloFiado.next(this.possuiRecurso(empresa, RecursosEnum.CONTROLE_FIADO));
    this.moduloFiscal.next(this.possuiRecurso(empresa, RecursosEnum.FISCAL));
    this.recursoGoogleMapsTaxas.next(this.possuiRecurso(empresa, RecursosEnum.GOOGLE_MAPS_TAXAS));
    this.moduloTabelaPrecos.next(this.possuiRecurso(empresa, RecursosEnum.TABELA_PRECOS));
    this.moduloComissionamento.next(this.possuiRecurso(empresa, RecursosEnum.COMISSIONAMENTO));
    this.atualizeRecursosSoltos(empresa);
    this.recarregueConfiguracaoFiscal(empresa);
  }

  private atualizeRecursosSoltos(empresa: any) {
    this.recursoAvaliacoesPedidos.next(this.possuiRecurso(empresa, RecursosEnum.AVALIACOES_PEDIDOS));
    this.recursoImpressaoAutomatica.next(this.possuiRecurso(empresa, RecursosEnum.IMPRESSAO_AUTOMATICA));
    this.recursoNotificacoesWhatsappPedidos.next(this.possuiRecurso(empresa, RecursosEnum.NOTIFICACOES_WHATSAPP_PEDIDOS));
    this.recursoIntegracaoGatewayPagamento.next(this.possuiRecurso(empresa, RecursosEnum.INTEGRACAO_GATEWAY_PAGAMENTO));
    this.recursoIntegracaoPdvParceiros.next(this.possuiRecurso(empresa, RecursosEnum.INTEGRACAO_PDV_PARCEIROS));
    this.recursoIntegracaoDeliveryParceiros.next(this.possuiRecurso(empresa, RecursosEnum.INTEGRACAO_DELIVERY_PARCEIROS));
    this.recursoIntegracaoMarketplacesDelivery.next(this.possuiRecurso(empresa, RecursosEnum.INTEGRACAO_MARKETPLACES_DELIVERY));
    this.recursoVitrines.next(this.possuiRecurso(empresa, RecursosEnum.VITRINES));
    this.recursoCuponsAvancados.next(this.possuiRecurso(empresa, RecursosEnum.CUPONS_AVANCADOS));
    this.recursoTemasPersonalizados.next(this.possuiRecurso(empresa, RecursosEnum.TEMAS_PERSONALIZADOS));
    this.recursoLinkNaBio.next(this.possuiRecurso(empresa, RecursosEnum.LINK_NA_BIO));
    this.recursoInteligenciaNegocio.next(this.possuiRecurso(empresa, RecursosEnum.INTELIGENCIA_NEGOCIO));
    this.recursoMiaAtendente.next(this.possuiRecurso(empresa, RecursosEnum.MIA_ATENDENTE));
    this.recursoCampanhasWhatsapp.next(this.possuiRecurso(empresa, RecursosEnum.CAMPANHAS_WHATSAPP));
    this.recursoNotificacoesAppProprio.next(this.possuiRecurso(empresa, RecursosEnum.NOTIFICACOES_APP_PROPRIO));
    this.recursoFerramentasMarketing.next(this.possuiRecurso(empresa, RecursosEnum.FERRAMENTAS_MARKETING));
  }

  getEmpresaAtual() {
    return this.empresa.getValue();
  }

  recarregueConfiguracaoFiscal(empresa: any = null) {
    const empresaAtual = empresa || this.empresa.getValue();
    if(!this.possuiRecurso(empresaAtual, RecursosEnum.FISCAL)) {
      this.emissaoNotaFiscalAtiva.next(false);
      this.impressaoAutomaticaNfce.next(false);
      return;
    }

    this.configuracoesNotaFiscalService.obtenhaConfiguracoesNotaFiscal().then((configuracoes: any) => {
      this.emissaoNotaFiscalAtiva.next(!!configuracoes?.emissaoNotaAtiva);
      this.impressaoAutomaticaNfce.next(!!configuracoes?.id && configuracoes.imprimirNfceAutomaticamente !== false);
    }).catch(() => {
      this.emissaoNotaFiscalAtiva.next(false);
      this.impressaoAutomaticaNfce.next(false);
    });
  }

  private carregueInformacoesDeHorarioDeFuncionamento(empresa: any) {
    if(!empresa || !empresa.horariosHoje) return;

    if(!empresa.horariosHoje.length) {
      empresa.descricaoHorario = "Fechado";
      if(!empresa.estaRecebendoPedidos)
        empresa.mensagemAbrirPedidos = empresa.mensagemPausaProgramada || 'Não estamos recebendo pedidos hoje'

    } else {
      empresa.descricaoHorario = this.diasDaSemana[empresa.horariosHoje[0].diaDaSemana];
      let descricoesHorario = [];

      for(let i = 0; i < empresa.horariosHoje.length; i++) {
        let horarioHoje = empresa.horariosHoje[i];
        if(!horarioHoje.funciona) {
          descricoesHorario.push("Fechado");

          if(!empresa.estaRecebendoPedidos)
            empresa.mensagemAbrirPedidos = empresa.mensagemPausaProgramada || 'Não estamos recebendo pedidos hoje'

          break;
        }
        descricoesHorario.push(horarioHoje.horarioAbertura.substr(0, 5)  + " - " + horarioHoje.horarioFechamento.substr(0, 5) );
      }
      if(!empresa.mensagemAbrirPedidos && empresa.horarioAbertura)
        empresa.mensagemAbrirPedidos = 'Abre às ' + empresa.horarioAbertura;

      empresa.descricaoHorario += " " + descricoesHorario.join(" | ");
    }

    if(empresa.estaAberta) {
      empresa.formasDeEntrega.forEach( (forma: any) => {
        if(forma.tempoMinimo && forma.tempoMaximo) {
          let unidade = forma.unidadeTempo === 'HORAS' ? 'h' : (forma.unidadeTempo === 'DIAS' ? 'dias' : 'min');
          empresa.descricaoTempoEntrega =  String(`${forma.tempoMinimo} ~ ${forma.tempoMaximo} ${unidade}`);
        }
      });

      if(!empresa.estaRecebendoPedidos)
        empresa.mensagemAbrirPedidos = empresa.mensagemFechada  || 'Fechamos por alguns minutos';
    }
  }

  toogleNaoImprimir() {
    this.armazenamentoService.salveSemExpirar(this.KEYNAOIMPRIMIR, this.naoImprimir ? '1' : '0')
  }

  toogleNaoTocarGarcom() {
    this.armazenamentoService.salveSemExpirar(this.KEYDESATIVARALERTAGARCOM, this.naoTocarGarcom ? '1' : '0')
  }

  togglePdvMostrarFotos() {
    this.armazenamentoService.salveSemExpirar(this.KEYPDVMOSTRARFOTOS, this.pdvMostrarFotos ? '1' : '0')
  }
}

/**
 * Enum responsável por definir os nomes dos módulos disponíveis,
 * removendo referências diretas a strings.
 */
export enum ModulosEnum {
  CHATBOT = 'chatbot',
  CHATBOT_INSTAGRAM = 'chatbot instagram',
  PEDIDOS = 'pedidos',
  MESAS_GARCOM = 'mesas_garcom',
  KDS = 'kds',
  FIDELIDADE = 'fidelidade',
  CARDAPIO = 'cardápio',
  GARCOM = 'garcom',
  ENTREGADORES = 'entregadores',
  PDV = 'pdv',
  CONTROLE_ESTOQUE = 'controle de estoque',
  APP = 'app',
  FIADO = 'controle fiado',
  FISCAL = 'fiscal',
  TABELA_PRECOS = 'tabela de precos',
  COMISSIONAMENTO = 'comissionamento',
  GOOGLE_MAPS = 'google api maps',
  DOMINIO_PROPRIO = 'dominio proprio',
  OPERADOR_EXTRA = 'operador extra',
}

export enum RecursosEnum {
  ATENDIMENTO_GARCOM = 'atendimento_garcom',
  CONTROLE_FIADO = 'controle_fiado',
  TABELA_PRECOS = 'tabela_precos',
  COMISSIONAMENTO = 'comissionamento',
  GOOGLE_MAPS_TAXAS = 'google_maps_taxas',
  CHATBOT_INSTAGRAM = 'chatbot_instagram',
  DOMINIO_PROPRIO = 'dominio_proprio',
  OPERADOR_EXTRA = 'operador_extra',
  CAIXA = 'caixa',
  ESTOQUE = 'estoque',
  FISCAL = 'fiscal',
  KDS_COZINHA = 'kds_cozinha',
  AVALIACOES_PEDIDOS = 'avaliacoes_pedidos',
  IMPRESSAO_AUTOMATICA = 'impressao_avancada',
  NOTIFICACOES_WHATSAPP_PEDIDOS = 'notificacoes_whatsapp_pedidos',
  INTEGRACAO_GATEWAY_PAGAMENTO = 'integracao_gateway_pagamento',
  INTEGRACAO_PDV_PARCEIROS = 'integracao_pdv_parceiros',
  INTEGRACAO_DELIVERY_PARCEIROS = 'integracao_delivery_parceiros',
  INTEGRACAO_MARKETPLACES_DELIVERY = 'integracao_marketplaces_delivery',
  VITRINES = 'vitrines',
  CUPONS_AVANCADOS = 'cupons_avancados',
  TEMAS_PERSONALIZADOS = 'temas_personalizados',
  LINK_NA_BIO = 'link_na_bio',
  INTELIGENCIA_NEGOCIO = 'inteligencia_negocio',
  ANALYTICS_CARDAPIO = 'analytics_cardapio',
  MIA_ATENDENTE = 'mia_atendente',
  MIA_V3 = 'mia_v3',
  CAMPANHAS_WHATSAPP = 'campanhas_whatsapp',
  NOTIFICACOES_APP_PROPRIO = 'notificacoes_app_proprio',
  FERRAMENTAS_MARKETING = 'ferramentas_marketing'
}
